import { clientFetch } from "@/utils/service";
import { FETCH_USERS } from './types';
import { qsToObj } from "@/utils/helpers";

export const fetchUsersListApi = async (query) => clientFetch('/admin/users/list', { query });
export const fetchUsersApi = async (query) => clientFetch('/admin/users', { query });
export const fetchUsers = (qs) => {
  const query = !!qs ? qsToObj(qs) : {};
  return {
    type: FETCH_USERS,
    payload: fetchUsersApi(query),
  };
};
